import { render, staticRenderFns } from "./GlobalConfirmDialog.vue?vue&type=template&id=5e0a60a3&scoped=true&"
import script from "./GlobalConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./GlobalConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./GlobalConfirmDialog.vue?vue&type=style&index=0&id=5e0a60a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0a60a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VIcon,VLayout,VSpacer})
